import I18n from 'I18n';
import { useMemo } from 'react';
import { useGetUsagePeriodUsageQuery as useGetInternalUsagePeriodUsageQuery } from '../../__generated__/chirp/com/hubspot/usagebasedbilling/experience/internal/rpc/UsageBasedBillingExperienceInternalRpc.hooks';
import { useGetUsagePeriodUsageWithTargetPortalQuery } from '../../__generated__/chirp/com/hubspot/usagebasedbilling/experience/rpc/UsageBasedBillingExperienceCrossHubletRpc.hooks';
import { useGetUsagePeriodUsageQuery } from '../../__generated__/chirp/com/hubspot/usagebasedbilling/experience/rpc/UsageBasedBillingExperienceRpc.hooks';
export const useGetUniversalUsagePeriodUsage = (options = {}) => {
  const {
    showBreakdown = false,
    skip = false,
    targetPortalId,
    isInternal = false
  } = options;
  const {
    data: externalData,
    loading: externalLoading,
    error: externalError,
    refetch: externalRefetch
  } = useGetUsagePeriodUsageQuery({
    variables: {
      showBreakdown
    },
    skip: skip || isInternal || targetPortalId != null
  });
  const {
    data: crossHubletData,
    loading: crossHubletLoading,
    error: crossHubletError,
    refetch: crossHubletRefetch
  } = useGetUsagePeriodUsageWithTargetPortalQuery({
    variables: {
      showBreakdown,
      targetPortalId
    },
    skip: skip || isInternal || targetPortalId == null
  });
  const {
    data: internalData,
    loading: internalLoading,
    error: internalError,
    refetch: internalRefetch
  } = useGetInternalUsagePeriodUsageQuery({
    variables: {
      showBreakdown,
      portalId: targetPortalId !== null && targetPortalId !== void 0 ? targetPortalId : 0
    },
    skip: skip || !isInternal
  });
  let data;
  let loading;
  let error;
  let refetch;
  if (isInternal) {
    data = internalData;
    loading = internalLoading;
    error = internalError;
    refetch = internalRefetch;
  } else if (targetPortalId) {
    data = crossHubletData;
    loading = crossHubletLoading;
    error = crossHubletError;
    refetch = crossHubletRefetch;
  } else {
    data = externalData;
    loading = externalLoading;
    error = externalError;
    refetch = externalRefetch;
  }
  const formattedData = useMemo(() => {
    if (!data) {
      return undefined;
    }
    const percentCreditsUsed = data.totalCredits ? data.creditsUsed / data.totalCredits * 100 : 0;
    return Object.assign({}, data, {
      daysUntilReset: Math.ceil(I18n.moment(data.endDate).diff(I18n.moment(), 'days', true)),
      userReadableEndDate: I18n.moment(data.endDate).add(1, 'day').toISOString(),
      percentCreditsUsed
    });
  }, [data]);
  return {
    data: formattedData,
    loading,
    error,
    refetch
  };
};